import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'awair-caret-switch',
  templateUrl: './caret-switch.component.html',
  styleUrls: ['./caret-switch.component.scss']
})
export class CaretSwitchComponent implements OnInit {

  @Input() length: number = 0;
  @Input()
  set initialIndex(value: number) {
    if (value != null) {
      this.index = value;
    }
  }
  @Output() changeIndex: EventEmitter<number> = new EventEmitter<number>();
  index: number = 0;

  constructor() {
  }

  ngOnInit() {
  }

  onClickLeft(index: number) {
    if (index > 0) {
      this.index--;
      this.changeIndex.emit(this.index);
    }
  }

  onClickRight(index: number) {
    if (index < (this.length - 1)) {
      this.index++;
      this.changeIndex.emit(this.index);
    }
  }
}
